<template>
    <layout title="Dashboard">
        <dashboard-news :items="news"></dashboard-news>
        <gin-member-dashboard :insights="insights" v-if="$page.props.auth.user.role === $GIN_ROLE" :emails="emails"></gin-member-dashboard>
        <customer-dashboard v-if="$page.props.auth.user.role === $CUSTOMER_ROLE"></customer-dashboard>
        <admin-dashboard v-if="$page.props.auth.user.role === $SUPER_ADMIN_ROLE || $page.props.auth.user.role === $ADMIN_ROLE"></admin-dashboard>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import GinMemberDashboard from "@/Components/Dashboard/GinMemberDashboard";
import AdminDashboard from "@/Components/Dashboard/AdminDashboard";
import CustomerDashboard from "@/Components/Dashboard/CustomerDashboard";
import DashboardNews from '@/Components/Dashboard/DashboardNews'

export default {
    components: {CustomerDashboard, AdminDashboard, GinMemberDashboard, DashboardNews, Layout},
    props: {
        news: {
            type: Array,
            default: [],
            required: false
        },
        insights: {
            type: [Object, Array],
            default: {},
            required: false
        },
        emails: {
            type: Array
        }
    },
    metaInfo() {
        return {
            title: `Home`,
        }
    },
}
</script>
